var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "143px",
    height: "25px",
    viewBox: "0 0 143 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E88\\u5B9A\\u3055\\u308C\\u3066\\u3044\\u308B\\u6388\\u696D",
    transform: "translate(-729.000000, -501.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(729.000000, 501.500000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u3082\\u3063\\u3068\\u8868\\u793A\\u3059\\u308B",
    fontFamily: "HiraginoSans-W3, Hiragino Sans",
    fontSize: 16,
    fontWeight: 300,
    letterSpacing: 1.33333333,
    fill: "#0091DC"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.333333333,
    y: 14
  }, "\u3082\u3063\u3068\u8868\u793A\u3059\u308B")), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-5",
    stroke: "#0091DC",
    strokeWidth: 2,
    strokeLinecap: "round",
    points: "132 11.75 137 16.75 142 11.75"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.66cd70f1afa5226b0b9764dcd46d37cb.svg";
export { ForwardRef as ReactComponent };